module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-9-cad8efe9bbfe6f9c2ce5672f84ac48f7.jpg";